<template>
  <div class="container com-list">
    <com-title :title="title" :subtitle="subtitle"></com-title>
    <ul class="columns">
      <li v-for="(item, index) in data" :key="index" class="column is-one-third">
        <img :src="item.img" alt="">
        <div class="title">{{item.title}}</div>
        <div class="word">{{item.word}}</div>
      </li>
    </ul>
  </div>
</template>
<script>
import comTitle from '@/base/title'
export default {
  data () {
    return {}
  },
  props: ['data', 'title', 'subtitle'],
  components: {
    comTitle
  }
}
</script>
<style scoped lang='sass'>
@import '../../style/variable.sass'

+mobile
  .container
    width: 88vw

div.com-list
  padding-bottom: 65px
  .columns
    flex-wrap: wrap
    li
      +mobile
        font-size: 14px
      .title
        font-size: 16px
        color: #353535
        margin: 14px 0 6px
        text-align: justify
        +mobile
          margin: 8px 0 2px
      .word
        font-size: 14px
        color: #888
        +mobile
          font-size: 14px
          margin: 5px 0
</style>
